import { Controller } from '@hotwired/stimulus';
import { showToast, clearToasts } from '../lib/toastr';

// Displays flash messages via toastr on connect.
// Works with both full page loads and Turbo navigations.
export default class extends Controller {
  static values = {
    messages: { type: Array, default: [] },
  };

  connect() {
    this.messagesValue.forEach(({ type, message }) => {
      showToast(type, message);
    });
  }

  // Clean up toastr containers before Turbo caches the page
  // to prevent ghost toasts from reappearing on back navigation
  teardown() {
    clearToasts();
  }

  // Design system preview: trigger a toast from a button click
  preview({ currentTarget }) {
    const { toastType, toastMessage } = currentTarget.dataset;
    showToast(toastType, toastMessage);
  }
}
